
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { ORDER_AUTO_ACCEPTED } from "@/constants/MixpanelEvents.js";
const GET_ORDER_INTERVAL_DELAY = 10000;
const GET_NOTIFICATION_INTERVAL_DELAY = 3600000; // 1hr

export default {
  data() {
    return {
      client: {},
      getOrderInterval: "",
      getOrderStopTimeout: "",
      getNotificationInterval: ""
    };
  },
  created() {
    if (this.isSocketDisabled) {
      this.initXHR();
    }
    this.$nuxt.$on("disconnect-socket", this.disconnectSocketConnection);
  },
  mounted() {
    // this.initXHR();
    // this.triggerPushNotification();
  },
  computed: {
    ...mapState("reciever", [
      "orders",
      "socketDetails",
      "orderDetails",
      "cancelledOrders",
      "cancelledOrdersTempList"
    ]),
    ...mapState("restaurant", ["locationDetails", "printers"]),
    ...mapState("auth", ["headers"]),
    ...mapGetters("restaurant", ["getRecieverSettings"]),
    ...mapGetters("reciever", ["getAllChannelNewOrders"]),
    isSocketDisabled() {
      return (
        !this.locationDetails?.features?.socket ||
        this.locationDetails?.features?.socket == "false"
      );
    },
    isAutoAcceptEnabledForAnyRestaurant() {
      return this.locationDetails.restaurants.some(
        (restaurant) => restaurant.settings?.enable_auto_accept
      );
    }
  },
  watch: {
    locationDetails: {
      handler(val) {
        if (!this.client?.readyState && !this.isSocketDisabled) {
          this.initNotificationXHR();
          this.establishSocketConnection();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions("reciever", [
      "getOrders",
      "patchOrderStatus",
      "getOrderDetails",
      "getOrderDetailsObj"
    ]),
    ...mapActions("restaurant", ["getLocationDetails", "getNotifications"]),
    ...mapMutations("reciever", [
      "ADD_NEW_ORDER",
      "ADD_NEW_CANCELLED_ORDER",
      "REMOVE_CANCELLED_ORDER_BY_ID"
    ]),
    initXHR() {
      this.initGetOrdersXHR();
      this.initNotificationXHR();
    },
    initNotificationXHR() {
      clearInterval(this.getNotificationInterval);
      this.getNotificationInterval = setInterval(
        (() => {
          this.getNotifications();
        }).bind(this),
        GET_NOTIFICATION_INTERVAL_DELAY
      );
    },
    initGetOrdersXHR() {
      // return;
      clearInterval(this.getOrderInterval);
      this.getOrderInterval = setInterval(async () => {
        if (!this.locationDetails?.id) return;
        const $this = this;
        const ordersIds = this.orders?.map((el) => el.id) || [];
        const cancelledOrdersIds =
          this.cancelledOrdersTempList == undefined
            ? null
            : this.cancelledOrdersTempList.map((el) => el.id) || [];
        try {
          const res = await this.getOrders({ handleCancelledOrders: true });

          if (res?.data?.orders?.live?.length) {
            let newItem = res.data.orders.live.filter((el) => {
              return (
                el.status == this.$constants.OrderStatuses.NEW_ORDER.id &&
                !ordersIds.includes(el.id)
              );
            });
            if (newItem.length > 0) {
              for (let index = 0; index < newItem.length; index++) {
                this.$nuxt.$emit(
                  "trigger-push-notification",
                  "New Order",
                  "Source: " +
                    this.getChannelConstObj(newItem[index].source).label,
                  newItem[index]
                );
                this.$nuxt.$emit("start-audio-alert");
                await this.handleNewOrderAutoAccept(newItem[index]); //enabling auto accept
              }
            }
          }

          // PROCESS CANCELLED ORDERS
          if (
            cancelledOrdersIds != null &&
            Array.isArray(cancelledOrdersIds) &&
            res?.data?.orders?.cancelled
          ) {
            res.data.orders.cancelled.forEach((el) => {
              if (
                !cancelledOrdersIds.includes(el.id) &&
                el.source !== "waiter"
              ) {
                this.handleNewCancelledOrder(el);
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        this.initAutoAcceptNewOrderChecker();
      }, GET_ORDER_INTERVAL_DELAY);
    },
    stopXHR() {
      this.stopGetOrdersXHR();
      this.stopGetNotificationXHR();
    },
    stopGetNotificationXHR() {
      clearInterval(this.getNotificationInterval);
      this.getNotificationInterval = "";
    },
    stopGetOrdersXHR() {
      this.getOrderStopTimeout = setTimeout(() => {
        if (this.getOrderInterval) {
          clearInterval(this.getOrderInterval);
          this.getOrderInterval = "";
        }
      }, GET_ORDER_INTERVAL_DELAY + 1000);
    },
    establishSocketConnection() {
      try {
        const socket_url = this.$nuxt.$config?.public?.SOCKET_URL;
        const access_token = this.headers["access-token"];
        const uid = this.headers["uid"];
        const client = this.headers["client"];
        const urlWithParams = `${socket_url}?access-token=${access_token}&uid=${uid}&client=${client}`;

        this.client = new WebSocket(urlWithParams);
        this.client.onopen = this.onConnect;

        this.client.onmessage = this.onMessageArrived;

        this.client.onclose = this.onConnectionLost;

        this.client.onerror = this.errorConnection;
        // //wss://13.233.109.67:16675/ws
        // console.log(
        //   "establishSocketConnection",
        //   this.socketDetails.host +
        //     " " +
        //     this.socketDetails.port +
        //     ", /ws " +
        //     this.locationDetails.name +
        //     this.locationDetails.id +
        //     "_" +
        //     this.$ls.get("v2-client")
        // );
        // var vm = this;
        // var creds = this.socketDetails.agent
        //   ? this.socketDetails.agent.split(":")
        //   : [];

        // // this.client = new Paho.Client('ws-uat.foaps.co', Number(data.port), "/ws",
        // //     "Rest_" + Vue.ls.get('id', '0') + "_" + Vue.ls.get('client'));
        // let RABBITMQ_SERVER = this.$nuxt.$config.SOCKET_URL; //
        // this.client = new Paho.MQTT.Client(
        //   RABBITMQ_SERVER,
        //   Number(this.socketDetails.port),
        //   "/ws",
        //   this.locationDetails.name +
        //     "_" +
        //     this.locationDetails.id +
        //     "_" +
        //     this.$ls.get("v2-client")
        // );

        // this.client.onConnectionLost = this.onConnectionLost;
        // this.client.onMessageArrived = this.onMessageArrived;
        // //   this.topic = this.socketDetails.topic;
        // // connect the client
        // this.client.connect({
        //   onSuccess: vm.onConnect,
        //   userName: creds[0],
        //   password: creds[1],
        //   cleanSession: false,
        //   reconnect: true,
        //   useSSL: true,
        //   //mqttVersion: 4,
        //   //mqttVersionExplicit: true,
        //   onFailure: vm.errorConnection
        //   //keepAliveInterval: 20000
        // });
      } catch (error) {
        console.error(error);
      }
    },
    onConnectionLost(e) {
      console.log("onConnectionLost", e);
      this.initXHR();
    },
    onConnect(e) {
      console.log("onConnect", e);
      // if (this.client?.readyState !== WebSocket.CLOSED) return;
      // if(this.client?.readyState === 1) return;
      // this.client?.close()
      const msg = {
        command: "subscribe",
        identifier: JSON.stringify({
          channel: "OrdersChannel",
          location_id: this.locationDetails.id
        })
      };

      this.client.send(JSON.stringify(msg));
      console.log("socket::: Connected to server.");
      this.stopXHR();
      // this.client.subscribe(this.socketDetails.topic, { qos: 1 });
    },
    errorConnection(e) {
      console.log("Socket:::errorConnection", e);
      this.initXHR();
    },
    handleNewCancelledOrder(data) {
      const FETCH_CHANNEL_STATE_TIMEROUT = 30000;
      setTimeout(
        (() => {
          this.getLocationDetails();
        }).bind(this),
        FETCH_CHANNEL_STATE_TIMEROUT
      );
      try {
        this.ADD_NEW_CANCELLED_ORDER(data);
        this.$nuxt.$emit(
          "trigger-push-notification",
          "Cancelled",
          "Source: " + this.getChannelConstObj(data.source).label,
          data
        );

        this.$nuxt.$emit("start-audio-alert");
        if (data.accepted_at) {
          this.getOrderDetailsObj({
            orderId: data.id
          })
            .then((response) => {
              this.$nuxt.$emit(
                "initiate-print",
                response,
                "kot",
                false,
                true,
                false,
                false,
                true,
                this.printers,
                "orderCancelled"
              );
              if (
                this.getRecieverSettings(response.restaurant_id)
                  .enable_consolidated_kot_printer
              ) {
                this.$nuxt.$emit(
                  "initiate-print",
                  response,
                  "master-kot",
                  false,
                  true,
                  false,
                  false,
                  true,
                  this.printers,
                  "orderCancelled"
                );
              }
            })
            .catch((errr) => {
              this.$nuxt.$emit("show-error-toast", errr);
            });
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", errr);
      }
    },
    async onMessageArrived(e) {
      let payload = e.data;
      if (
        payload.charAt(0) === '"' &&
        payload.charAt(payload.length - 1) === '"'
      ) {
        payload = payload.substr(1, payload.length - 2);
      }
      const parsedPayload = JSON.parse(payload);
      if (!parsedPayload.identifier || !parsedPayload.message) return;
      const type = parsedPayload.message?.type;
      const parsedData = JSON.parse(
        parsedPayload.message?.order?.replace(/\\/g, "")
      );
      const parsedIdentifier = JSON.parse(
        parsedPayload.identifier?.replace(/\\/g, "")
      );
      console.log("***SOCKET MSG START***");
      console.log(type, parsedData);
      console.log("***SOCKET MSG END***");
      switch (type) {
        case "counter_sale": {
          //dashboard delivery/ takeaway
          // this.orders.unshift(parsedData.data);
          // this.validatePrintJob(parsedData, true);
          break;
        }
        case "new_order": {
          //new waiter app order
          this.ADD_NEW_ORDER(parsedData);
          this.$nuxt.$emit(
            "trigger-push-notification",
            "New Order",
            "Source: " + this.getChannelConstObj(parsedData.source).label,
            parsedData
          );
          this.$nuxt.$emit("start-audio-alert");
          this.handleNewOrderAutoAccept(parsedData); //enabling auto accept
          break;
        }
        case "order_acknowledged": {
          await this.getOrders();
          if (!this.getAllChannelNewOrders?.length)
            this.$nuxt.$emit("stop-audio-alert");
          break;
        }
        case "order_food_ready": {
          this.getOrders();
          break;
        }
        case "order_dispatched": {
          this.getOrders();
          break;
        }
        case "order_completed": {
          this.getOrders();
          break;
        }
        case "order_modified": {
          this.getOrders();
          break;
        }
        case "order_cancelled": {
          const found = this.cancelledOrders.find(
            (el) => el.id == parsedData.id
          );
          if (!found) {
            this.handleNewCancelledOrder(parsedData);
          }
          break;
        }
        case "order_cancellation_acknowledged": {
          await this.REMOVE_CANCELLED_ORDER_BY_ID(parsedData.id);
          console.log(
            "this.cancelledOrders.length:::",
            this.cancelledOrders.length
          );
          if (!this.cancelledOrders.length) {
            this.$nuxt.$emit("stop-audio-alert");
          }
          break;
        }
      }
      this.initAutoAcceptNewOrderChecker();
      // if (this.orderDetails?.id == parsedData.data?.id) {
      //   this.getOrderDetails({
      //     orderId: parsedData.data.id
      //   });
      // }
    },
    disconnectSocketConnection() {
      try {
        clearInterval(this.getOrderInterval);
        this.client.disconnect();
      } catch (e) {
        console.log(e);
      }
    },

    checkAndSyncAutoAcceptNewOrder() {
      const newOrders = this.getAllChannelNewOrders;
      if (newOrders.length) {
        newOrders.forEach((order) => {
          if (
            this.getRecieverSettings(order.restaurant_id).enable_auto_accept
          ) {
            this.handleNewOrderAutoAccept(order);
          }
        });
      }
    },
    initAutoAcceptNewOrderChecker() {
      if (this.isAutoAcceptEnabledForAnyRestaurant) {
        setTimeout(
          (() => {
            this.checkAndSyncAutoAcceptNewOrder();
          }).bind(this),
          2000
        );
      }
    },
    async handleNewOrderAutoAccept(order) {
      if (this.getRecieverSettings(order.restaurant_id).enable_auto_accept) {
        const $this = this;
        try {
          const response = await this.patchOrderStatus({
            orderId: order.id,
            payload: {
              new_status: "Acknowledged"
            }
          });
          this.$nuxt.$emit("stop-audio-alert");
          if (response.status === 200) {
            this.mixPanelTrackEvent(ORDER_AUTO_ACCEPTED);
            try {
              const orderDetails = await this.getOrderDetailsObj({
                orderId: order.id
              });
              if (orderDetails) {
                this.kotPrintAllItems(orderDetails);
              } else {
                this.$nuxt.$emit("show-error-toast", orderDetails);
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            this.$nuxt.$emit("show-error-toast", orderDetails);
          }
        } catch (error) {
          console.log(error);
          this.$nuxt.$emit("show-error-toast", error);
        }
      }
    },
    kotPrintAllItems(order) {
      this.$nuxt.$emit(
        "initiate-print",
        order,
        "kot",
        false,
        true,
        false,
        false,
        true,
        this.printers
      );
      if (
        this.getRecieverSettings(order.restaurant_id)
          .enable_consolidated_kot_printer
      ) {
        this.$nuxt.$emit(
          "initiate-print",
          order,
          "master-kot",
          false,
          true,
          false,
          false,
          true,
          this.printers
        );
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("disconnect-socket");
  }
};
